<template>
  <div
    class="rounded py-3 md:py-5 bg-white my-5 mx-2 md:my-0 md:max-w-screen-lg md:mx-auto"
  >
    <h2 class="font-bold text-xl py-5 px-3 md:px-10">Settings</h2>

    <div class="px-2 md:px-10 flex flex-wrap flex-row">
      <div
        class="mr-3 my-1"
        v-for="tab in tabs"
        :key="tab.tab"
        @click="setTab(tab.tab)"
      >
        <StyledTab :active="currentTab === tab.tab">{{ tab.label }}</StyledTab>
      </div>
    </div>

    <div class="py-3 px-2 md:px-10">
      <router-view />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters(["getCurrentUser", "getCurrentUserContext"])
  },
  mounted() {
    if (this.$route.name !== "dashboard_settings") {
      this.currentTab = this.$route.name.split("dashboard_settings_")[1]
    } else {
      if (this.getCurrentUserContext === "landlord") {
        this.$router.push({ name: "dashboard_settings_profile" })
      } else {
        this.$router.push({ name: "dashboard_settings_password" })
      }
    }

    if (this.getCurrentUser) {
      if (this.getCurrentUserContext === "applicant") {
        this.tabs = [
          {
            tab: "password",
            label: "Password"
          }
        ]
      } else {
        if (
          this.getCurrentUser.landlord.payments_enabled &&
          this.getCurrentUser.landlord.show_my_payments
        ) {
          this.tabs.push({
            tab: "bank_account",
            label: "Bank Account"
          })
        }
      }
    }
  },
  data() {
    return {
      currentTab: "profile",
      tabs: [
        {
          tab: "profile",
          label: "Profile Information"
        },
        {
          tab: "notifications",
          label: "Notifications"
        },
        {
          tab: "password",
          label: "Password"
        }
      ]
    }
  },
  methods: {
    setTab(tab) {
      this.currentTab = tab
      this.$router.push({ name: `dashboard_settings_${tab}` })
    }
  }
}
</script>
